import { render, staticRenderFns } from "./CallHistoryComp.vue?vue&type=template&id=c481a16e&scoped=true&"
import script from "./CallHistoryComp.vue?vue&type=script&lang=js&"
export * from "./CallHistoryComp.vue?vue&type=script&lang=js&"
import style0 from "./CallHistoryComp.vue?vue&type=style&index=0&id=c481a16e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c481a16e",
  null
  
)

export default component.exports